<template>
  <div class="field-giftaid">
    <p>
      I am a UK taxpayer and understand that if I pay less Income Tax and/or
      Capital Gains Tax in the current tax year than the amount of Gift Aid
      claimed on all my donations it is my responsibility to pay any difference.
    </p>
    <SvgoGiftaid />
    <FormFieldCheck
      v-bind="{
        index,
        type: 'checkbox',
        title: hint.text,
        attrs: {
          ...$attrs,
          type: 'checkbox',
        },
      }"
      class="required"
      v-model="value"
    />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  index: Number,
  title: String,
  hint: {
    type: Object,
    default: () => ({ text: '' }),
  },
  modelValue: [String, Number, Boolean, Array],
})
const emit = defineEmits(['update:modelValue'])

const value = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})
</script>

<style lang="scss">
.form-field-giftaid {
  .field-giftaid {
    display: flex;
    flex-flow: row wrap;
    align-items: center;

    svg {
      width: 50%;
      padding-top: czn.$rg;
      padding-right: czn.$lg;
    }

    p {
      width: 100%;
      font-size: 0.8em;
    }
    

    .form-inline-group {
      width: auto;
    }
  }
}
</style>
